import { useState } from 'react'

//Components
import SelectAddress from 'pages/dashboard/e-reporting/forms/components/reuseables/select-address/SelectAddress'

//Hoc
import withFetch from './withFetch'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function PilihKotaPemilikProvinsi({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form } = useFormState()

  const [selectedData, setSelectedData] = useState({
    ...form.kota_pemilik_properti.value,
    value: form.kota_pemilik_properti.value.id,
    label: form.kota_pemilik_properti.value.name
  })

  const onNext = () => {
    handlePrevState()
    formHandler('kota_pemilik_properti', selectedData)
    setCurrentStep(STEPS.areaPemilikProperti)
  }

  return (
    <SelectAddress
      order="b. "
      question={'Di kota mana domisili pemilik?'}
      placeholder="Tulis kota"
      required
      data={data}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      onNext={onNext}
      disabled={isAprroval}
    />
  )
}

export default withFetch(PilihKotaPemilikProvinsi)